var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Form, Message, Modal, TextArea } from "semantic-ui-react";
import { getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
/**
 * Admin-only design comment for one probe of an order item (channel distinguishes multiplex
 * probes). Stored per probe — not on the kit or order — so design info no longer needs to live
 * in order comments, and it flows into the design sheet's Designer Notes column automatically.
 * Saving a blank comment removes it.
 */
var ProbeDesignCommentModal = /** @class */ (function (_super) {
    __extends(ProbeDesignCommentModal, _super);
    function ProbeDesignCommentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.open = function () {
            _this.setState({ open: true, loading: true, error: undefined, saved: false });
            getWithAuthn("/probe-design/comments/" + encodeURIComponent(_this.props.orderId))
                .then(function (resp) {
                if (resp.status !== 200) {
                    throw new Error("" + resp.status);
                }
                return resp.json();
            })
                .then(function (body) {
                var _a;
                var existing = body.comments.find(function (c) { return c.itemId === _this.props.itemId && c.channel === _this.props.channel; });
                _this.setState({
                    loading: false,
                    comment: (_a = existing === null || existing === void 0 ? void 0 : existing.comment) !== null && _a !== void 0 ? _a : '',
                    hasExisting: existing != null
                });
            })
                .catch(function () {
                _this.setState({ loading: false, error: 'The design comment could not be loaded.' });
            });
        };
        _this.close = function () {
            _this.setState({ open: false });
        };
        _this.save = function () {
            _this.setState({ saving: true, error: undefined, saved: false });
            postJsonWithAuthn('/probe-design/comment', JSON.stringify({
                itemId: _this.props.itemId,
                channel: _this.props.channel,
                comment: _this.state.comment
            }))
                .then(function (resp) {
                if (resp.status === 200) {
                    _this.setState({ saving: false, saved: true, hasExisting: _this.state.comment.trim() !== '' });
                }
                else {
                    _this.setState({ saving: false, error: 'The design comment could not be saved.' });
                }
            })
                .catch(function () {
                _this.setState({ saving: false, error: 'The design comment could not be saved.' });
            });
        };
        _this.state = {
            open: false,
            loading: false,
            saving: false,
            comment: '',
            hasExisting: false,
            error: undefined,
            saved: false
        };
        return _this;
    }
    ProbeDesignCommentModal.prototype.render = function () {
        var _this = this;
        var channelSuffix = this.props.multiplex ? " (Ch " + this.props.channel + ")" : '';
        return React.createElement(Modal, { closeIcon: true, size: 'small', open: this.state.open, onClose: this.close, trigger: React.createElement(Button, { icon: 'sticky note outline', label: "Design Comment" + channelSuffix, labelPosition: 'left', onClick: this.open }) },
            React.createElement(Modal.Header, null,
                "Probe design comment",
                channelSuffix),
            React.createElement(Modal.Content, null,
                React.createElement("p", null, "Internal note for the probe design team \u2014 never shown to the customer. It appears in the design sheet's Designer Notes column and in the probe design review. Save an empty comment to remove it."),
                this.state.error &&
                    React.createElement(Message, { negative: true }, this.state.error),
                this.state.saved &&
                    React.createElement(Message, { positive: true }, "Saved."),
                React.createElement(Form, { loading: this.state.loading },
                    React.createElement(TextArea, { rows: 4, placeholder: 'e.g. avoid the 3′ UTR; customer confirmed isoform 2', value: this.state.comment, onChange: function (_, data) { var _a; return _this.setState({ comment: String((_a = data.value) !== null && _a !== void 0 ? _a : ''), saved: false }); } }))),
            React.createElement(Modal.Actions, null,
                React.createElement(Button, { positive: true, icon: 'save', content: this.state.comment.trim() === '' && this.state.hasExisting ? 'Remove comment' : 'Save', loading: this.state.saving, disabled: this.state.saving || this.state.loading, onClick: this.save })));
    };
    return ProbeDesignCommentModal;
}(React.PureComponent));
export default ProbeDesignCommentModal;
//# sourceMappingURL=ProbeDesignCommentModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ProbeDesignCommentModal.js
// module id = 1249
// module chunks = 0